import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import InfoPopup from '~/components/InfoPopup'
import { useFormContext, useWatch } from 'react-hook-form'
import { formatNumber } from '~/utils/helpers'
import WarningIcon from '../WarningIcon'
import ErrorIcon from '../ErrorIcon'

const AttritionRate:React.FC = () => {
  const { control, setError, clearErrors } = useFormContext()

  const watchSlaughterCowsNumber = useWatch({ control, name: 'slaughterCowsNumber' })
  const watchCowLosses = useWatch({ control, name: 'cowLosses' })
  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })

  const attrition = useMemo(() => {
    const slaughteredCows = parseInt(watchSlaughterCowsNumber || 0)
    const cowLosses = parseInt(watchCowLosses || 0)
    const transformedCowsNumber = watchCowsNumber?.toString()?.replace(',', '.')
    const sum = cowLosses + slaughteredCows
    const attrition = transformedCowsNumber > 0 && !isNaN(transformedCowsNumber) ? sum / transformedCowsNumber * 100 : 0.00

    if(attrition > 100) {
      setError('attritionRate', { message: 'Die maximale Abgangsquote liegt bei 100%.' })
    } else {
      clearErrors('attritionRate')
    }

    return attrition

  }, [watchSlaughterCowsNumber, watchCowLosses, watchCowsNumber])

  return <>
    <MilkProductionField>
      <label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{'Abgangsquote'}</label>
          <InfoPopup
            content={`Dieses Feld stellt sowohl die Abgangsquote (bspw. Schlachtkuhverkäufe) inklusive der Zuchtviehverkäufe, 
              also auch die Bestandsergänzung dar und wurde automatisch aus den vorigen Angaben berechnet. 
              Auf Grundlage dieser Zahlen werden Emissionen für die Schlachtkühe sowie die Bestandsergänzung kalkuliert.`}
            styleIcon={{ fontSize: '1.2em' }}
            position={'top center'}
          />
          {attrition > 40 && <WarningIcon
            control={control}
            valueField={attrition}
            name='attritionRate'
            content={'Die errechnete Abgangsquote liegt über dem normalen Bereiche von 40%.'}
          />}
          <ErrorIcon
            control={control}
            name={'Die maximale Abgangsquote liegt bei 100%.'}
          />
        </div>
      </label>
      <div>{`${formatNumber(attrition, 2)} %`}</div>
    </MilkProductionField>
  </>
}
export default AttritionRate